import { useAPI } from '@shared/lib/composables';
import type { HttpStatusCode } from '~/shared/types';

export interface ChoosingFormRequest {
  // Регион клиента
  region: string;
  // ФИО клиента
  fullName: string;
  // Номер телефона клиента
  phone: string;
  // Email адрес клиента
  email: string;
}

export interface ChoosingFormResponse {
  success: boolean;
  message?: string;
  status: HttpStatusCode;
  errors?: unknown;
}

/**
 * Обращение с целью заказа звонка по системе КонсультантПлюс
 * @param requestBody ChoosingFormRequest
 * @returns Promise<ChoosingFormResponse>
 */
export function sendChoosingForm(requestBody: ChoosingFormRequest): Promise<ChoosingFormResponse> {
  const config = useRuntimeConfig();
  const route = useRoute();

  const apiUrl = `${config.public.apiUrl}/v1/forms/kpus/choosing`;

  const body = {
    form_id: '3738d980-2307-4925-9923-c097c57622e9',
    form_url: config.public.siteUrl + route.fullPath,
    ...requestBody };

  return useAPI<ChoosingFormResponse>(apiUrl, { method: 'POST', body });
};
